import React from 'react';

import { Flex, Spacing, Skeleton } from '@zoomit/primitives';

const ProductSimpleListItemDesktopSkeleton = () => {
  return (
    <Flex alignItems="center" justifyContent="space-between" spacing={{ pl: 'x4' }}>
      <Flex gap={Spacing.x4} alignItems="center">
        <Skeleton variant="rectangular" width={7.2} height={5.15} />
        <Skeleton variant="text" width={25} />
      </Flex>
      <Flex justifyContent="flex-end" gap={Spacing.x8} alignItems="center">
        <Skeleton variant="text" width={5} />
        <Skeleton variant="text" width={11} />
      </Flex>
    </Flex>
  );
};

export default ProductSimpleListItemDesktopSkeleton;
